<div class="inner-content">
    <div class="documents-list">

        <p class="list-header">
            Wybierz dokumenty i kliknij "Dalej"
        </p>
        <form [formGroup]="searchForm" class="search-form">
            <input type="text" placeholder="Wyszukaj dokumenty" formControlName="search">

            <span class="close" (click)="clearSearch()" *ngIf="searchText"></span>
        </form>

        <div class="group" *ngFor="let group of documents?.data;">
            <div class="title">
                {{ group.name }}
            </div>
            <div class="documents">
                <div class="item" *ngFor="let doc of group?.documents;">
                    <input type="checkbox" [id]="group.id + '_' + doc.id" [(ngModel)]="model[doc?.id]">

                    <label class="text" [htmlFor]="group.id + '_' + doc.id">
                        <span nsFilterHighlighter>{{ doc?.name }}</span>
                        <span class="type">{{ doc?.file?.extension }}</span>
                    </label>

                    <span class="download-wrapper" (click)="downloadDocument(doc)">
                        <span class="item-icon download"></span>
                    </span>
                </div>
            </div>
        </div>

        <div class="group" *ngIf="myDocuments?.data?.length">
            <div class="title">
                MOJA BIBLIOTEKA
            </div>
            <div class="documents">
                <div class="item" *ngFor="let doc of myDocuments?.data;">
                    <input type="checkbox" [id]="'myDocs_' + doc.id" [(ngModel)]="model['MYDOC_' + doc?.id]">

                    <label class="text" [htmlFor]="'myDocs_' + doc.id">
                        <span nsFilterHighlighter>{{ doc?.name }}</span>
                        <span class="type">{{ doc?.file?.extension }}</span>
                    </label>

                    <span class="download-wrapper" (click)="downloadDocument(doc)">
                        <span class="item-icon download"></span>
                    </span>
                </div>
            </div>
        </div>

        <div class="group" *ngIf="!documents?.data?.length && !myDocuments?.data?.length">
            <h2 class="no-results">Brak wyników</h2>
        </div>

    </div>
</div>

<ns-floating-footer
    (backClick)="onGoBack()"
    (mainClick)="onNext()"
></ns-floating-footer>